<app-modal-basic #generatePackagingLabelModal [dialogClass]="'modal-md'">
  <div class="app-modal-header">
    <h4 class="modal-title">
      {{'admin.packaging_label.generate_title'| translate }}
    </h4>
    <button type="button" class="close basic-close" (click)="closeGeneratePackagingLabelModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form novalidate #createPackagingLabelForm="ngForm">
      <div *ngIf="!hideDeliveryDealer">
        <p>{{'doctrine.attributes.dealer' | translate}}</p>
        <div class="form-group row">
          <div class="form-group form-default form-static-label col-12">
            <ng-select required name="dealer" id="dealer" [items]="dealers$" bindLabel="companyName" bindValue="id"
                       [(ngModel)]="packagingLabel.deliveryDealer" [clearable]="false"
                       [typeahead]="dealerTypeHead">
            </ng-select>
          </div>
        </div>
      </div>
      <p>{{'admin.packaging_label.items_label'|translate }}</p>
      <hr>
      <ng-container *ngFor="let packagingLabelItem of packagingLabel.packagingLabelItems; let i = index">
        <div class="form-row row px-2">
          <div class="form-group col-md-6 px-1">
            <label [for]="'description' + i">{{"admin.packaging_label.item_description" | translate}}<span
              class="star">*</span></label>
            <input required [name]="'description' + i"
                   [id]="'description' + i"
                   class="form-control"
                   #description="ngModel"
                   [(ngModel)]="packagingLabelItem.description">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="description.invalid && description.dirty && description.errors?.required">
              {{'errors.required'|translate}}
            </div>
          </div>
          <div class="form-group col-md-5 px-1">
            <label [for]="'number' + i">{{"admin.packaging_label.item_number" | translate}}   <span
              class="star">*</span></label>
            <input required [name]="'number' + i"
                   type="number"
                   step="1"
                   min="1"
                   [id]="'number' + i"
                   class="form-control"
                   #number="ngModel"
                   [(ngModel)]="packagingLabelItem.number">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="number.invalid && number.dirty && number.errors?.required">
              {{'errors.required'|translate}}
            </div>
            <div class="messages text-danger"
                 *ngIf="number.errors?.min">
              {{'errors.positive_rang'|translate }}
            </div>
          </div>
          <div class="form-group col-md-1 mt-4 px-1" *ngIf="i !== 0">
            <a class="btn btn-lg btn-icon ripple light mt-1" (click)="removePackagingLabelItem(i)">
              <i class="fa fa-trash trash-danger"></i>
            </a>
          </div>
        </div>
      </ng-container>
      <button class="btn btn-primary ripple light mb-0 mt-0" (click)="addPackagingLabelItem()">
        <i class="fa fa-plus fa-fw"></i>
        &nbsp;{{'global.add' | translate}}
      </button>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="closeGeneratePackagingLabelModal()">{{'global.cancel'|translate}}</button>
    <button type="submit" class="btn btn-primary ripple light" (click)="generatePackagingLabel()"
            [disabled]="!createPackagingLabelForm.valid">
      {{ 'admin.order.custom_invoice.modal.confirm' | translate}}
    </button>
  </div>
</app-modal-basic>
